import { IVoiceDTO } from '@/modules/voices/dtos/voice.dto';
import { IVoice } from '@/modules/voices/entities/voice.entity';

export class VoiceMapper {
  public static toPresentation(voice: IVoiceDTO): IVoice {
    return {
      id: voice.id,
      name: voice.nome,
      slug: voice.slug,
      gender: voice.genero,
    };
  }

  public static toDTO(voice: IVoice): IVoiceDTO {
    return {
      id: voice.id,
      nome: voice.name,
      slug: voice.slug,
      genero: voice.gender,
    };
  }
}
